import { astInitialState, astSlice } from './ast';
import { cupsInitialState, cupsSlice } from './cups';
import { editorInitialState, editorSlice } from './editor';
export var allReducer = {
    ast: astSlice.reducer,
    cups: cupsSlice.reducer,
    editor: editorSlice.reducer,
};
export var allInitialState = {
    ast: astInitialState,
    cups: cupsInitialState,
    editor: editorInitialState,
};
